// Shared geo helpers.
// Mirrors haversineMeters in server/utils/awsLocationService.js so client-side
// proximity checks agree with the server's completion gate.

const EARTH_RADIUS_METERS = 6371000

const toRad = (deg) => (deg * Math.PI) / 180

/**
 * Great-circle distance in metres between two {lat, lng} points.
 * Returns Infinity when either point is missing or non-numeric, so callers can
 * treat "unknown distance" as "not close enough" without extra guards.
 */
export function haversineMeters(a, b) {
  if (!a || !b) return Number.POSITIVE_INFINITY

  const aLat = Number(a.lat)
  const aLng = Number(a.lng)
  const bLat = Number(b.lat)
  const bLng = Number(b.lng)

  if (![aLat, aLng, bLat, bLng].every(Number.isFinite)) return Number.POSITIVE_INFINITY

  const dLat = toRad(bLat - aLat)
  const dLng = toRad(bLng - aLng)
  const x =
    Math.sin(dLat / 2) ** 2 +
    Math.sin(dLng / 2) ** 2 * Math.cos(toRad(aLat)) * Math.cos(toRad(bLat))

  return EARTH_RADIUS_METERS * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x))
}

/** Human-readable distance for driver-facing copy: "340 m" / "1.2 km". */
export function formatDistance(meters) {
  if (!Number.isFinite(meters)) return null
  if (meters < 1000) return `${Math.round(meters)} m`
  return `${(meters / 1000).toFixed(1)} km`
}
